export const entities = [
  { key: 'Appointment', name: 'Agendamentos' },
  { key: 'Entity', name: 'Cadastro de pessoas' },
  { key: 'Cashier', name: 'Caixa' },
  { key: 'ApiKey', name: 'Chaves de API' },
  { key: 'Client', name: 'Clientes' },
  { key: 'Collaborator', name: 'Colaboradores' },
  { key: 'Settings', name: 'Configurações' },
  { key: 'DoctoraliaMapping', name: 'Doctoralia' },
  { key: 'Branch', name: 'Empresas' },
  { key: 'Forward', name: 'Encaminhamentos' },
  { key: 'Provider', name: 'Fornecedores' },
  { key: 'Schedule', name: 'Gerenciamento de agendas' },
  { key: 'PermissionGroup', name: 'Grupo de permissões' },
  { key: 'BillingAccount', name: 'Guias' },
  { key: 'Financial', name: 'Lançamento financeiro' },
  { key: 'PrintTemplate', name: 'Modelos de impressos' },
  { key: 'MxMedMapping', name: 'MxMed' },
  { key: 'Patient', name: 'Pacientes' },
  { key: 'Partner', name: 'Parceiros' },
  { key: 'Insurance', name: 'Planos de saúde' },
  { key: 'PortalSettings', name: 'Portal de agendamentos' },
  { key: 'Professional', name: 'Profissionais' },
  { key: 'Expense', name: 'Serviços, taxas e outras despesas' },
  { key: 'ExpenseTable', name: 'Tabelas de preços' },
  { key: 'User', name: 'Usuário' },
];

export function get(key) {
  return entities.find(item => item.key === key);
}

export function getName(key) {
  const entity = get(key);
  return entity ? entity.name : key;
}

export default entities;
